// extracted by mini-css-extract-plugin
export var active = "header-module--active--6f203";
export var content = "header-module--content--7c5d0";
export var dark = "header-module--dark--9c6f3";
export var link = "header-module--link--fac36";
export var links = "header-module--links--6d86c";
export var logo = "header-module--logo--580a1";
export var min = "header-module--min--ef672";
export var toggle = "header-module--toggle--8676b";